// extracted by mini-css-extract-plugin
export default {"record-writebox":"BloodPressureWrite_record-writebox__W9CX8","date-record":"BloodPressureWrite_date-record__KdPQG","time-record":"BloodPressureWrite_time-record__TCvAe"};